export const SET_USER = 'SET_USER' // 设置用户信息
export const SET_SCHEDULE_DATA = 'SET_SCHEDULE_DATA' // 改变某一周
export const SET_ADD_SCHEDULE_DATA_ITEM = 'SET_ADD_SCHEDULE_DATA_ITEM' // 增加一行
export const SET_DELETE_SCHEDULE_DATA_ITEM = 'SET_DELETE_SCHEDULE_DATA_ITEM' // 删除一行
export const SET_REPLACE_SCHEDULE_DATA = 'SET_REPLACE_SCHEDULE_DATA' // 替换整个schedule
export const SET_RETSET_SCHEDULE_DATA = 'SET_RETSET_SCHEDULE_DATA' // 重置
export const SET_RESOURCE_CLIPBOARD = 'SET_RESOURCE_CLIPBOARD' // 设置资源剪切板
export const SET_SYSTEM_INDEX = 'SET_SYSTEM_INDEX' // 设置系统序号